import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Avatar,
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Close, PersonOutline } from "@mui/icons-material";
import FormUser from "./FormUser";

export default function UserDialog({ open, onClose, onSubmit, user }) {
  const [busy, setBusy] = useState(false);
  const fullScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const close = () => {
    if (!busy) onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={close}
      fullWidth
      maxWidth="md"
      fullScreen={fullScreen}
      aria-labelledby="user-dialog-title"
      PaperProps={{
        sx: {
          borderRadius: { xs: 0, sm: 3 },
          width: { sm: "calc(100% - 48px)" },
          maxWidth: 820,
          maxHeight: { sm: "92dvh" },
          m: { sm: 3 },
        },
      }}
    >
      <DialogTitle
        id="user-dialog-title"
        sx={{
          px: { xs: 2, sm: 3 },
          py: 2.5,
          display: "flex",
          alignItems: "center",
          gap: 2,
          color: "#fff",
          background: "linear-gradient(120deg, #1a73e8, #49a3f1)",
        }}
      >
        <Avatar sx={{ bgcolor: "rgba(255,255,255,.18)", color: "#fff" }}>
          {user?.username?.charAt(0).toUpperCase() || <PersonOutline />}
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography component="span" display="block" variant="h6" color="inherit">
            {user ? "Editar usuario" : "Crear usuario"}
          </Typography>
          <Typography
            variant="body2"
            color="inherit"
            sx={{ opacity: 0.85, overflowWrap: "anywhere" }}
          >
            {user ? `${user.username} · ID ${user.id}` : "Datos de la cuenta y acceso al sistema"}
          </Typography>
        </Box>
        <IconButton
          aria-label="Cerrar modal"
          onClick={close}
          disabled={busy}
          sx={{ color: "inherit" }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <FormUser
        key={user?.id ?? "new"}
        initialData={user ? { ...user, status: Number(user.status ?? 1) } : {}}
        userId={user?.id}
        isEditMode={Boolean(user)}
        onSubmit={onSubmit}
        onCancel={close}
        onBusyChange={setBusy}
      />
    </Dialog>
  );
}
UserDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  user: PropTypes.object,
};
